<template>
  <v-slide-y-transition mode="out-in">
    <div>
      <!--<v-container grid-list-xl class="pb-0">
        <v-layout row wrap>
          <v-flex lg12 xs12>
            <v-btn-toggle small v-model="toggle_tingkat" class="mr-3" multiple dark>                
              <v-btn round small v-for="(tingkat) in tingkats" :value="tingkat.id" :color="getColor(tingkat.id>2?3:tingkat.id)">{{tingkat.nama}}</v-btn>                
            </v-btn-toggle>
          </v-flex>
        </v-layout>
      </v-container>-->     
      <mini-statistic :toggle_tingkat="toggle_tingkat"></mini-statistic>
      <chart-statistic :toggle_tingkat="toggle_tingkat"></chart-statistic>
    </div>  
  </v-slide-y-transition>  
</template>
<script>
import MiniStatistic  from './layout/mini-statistic';
import ChartStatistic from './layout/chart-statistic';
import Model from '@/apps/admin/models/Dashboard';
import User  from '@/util/models/User';

const model = new Model();

export default {
  components: {
    MiniStatistic, ChartStatistic
  },
  data () {
    return {
      roles : User.roles(),
      tingkats : [],
      toggle_tingkat : [],
    };
  },  
  computed: {    
            
  },
  mounted(){
    model.tingkats().then(data=>{this.tingkats = data});
  },
  methods:{
     getColor(tingkat){
      switch(tingkat){case 1:return 'red darken-2'; case 2: return 'indigo'; case 3:return 'blue-grey'; default:return 'black';}
    },
  }
};
</script>

